import { Inbox } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { I18n } from "aws-amplify/utils";
const NoData = () => {
    return (
        <Box sx={{ 
          
            }} mb={0} mt={0}>
            <Box mt={0}>
              
            </Box>
        </Box>
        
    );
};
export default NoData;